export default __webpack_public_path__ + "static/pragicts-ai-manufacturing-a63f23882f000719dc1d8c2010c3c38e.jpg";